import { normalizePlan } from './planConfiguration';

export type PlanStatus = 'loading' | 'ready' | 'error';

export interface PlanState {
  /** The plan key, only when status is 'ready'. Never a stand-in while loading or after a failed read. */
  plan: string | null;
  status: PlanStatus;
  retry: () => Promise<void>;
}

export interface PlanSource {
  orgInstance: { orgInstanceSubscriptionPlan?: string | null } | null;
  loading: boolean;
  error: Error | null;
}

// A plan read once stays usable while a later refresh is in flight or fails
export function derivePlanState({ orgInstance, loading }: PlanSource): Omit<PlanState, 'retry'> {
  if (orgInstance) return { plan: normalizePlan(orgInstance.orgInstanceSubscriptionPlan ?? ''), status: 'ready' };
  if (loading) return { plan: null, status: 'loading' };
  return { plan: null, status: 'error' };
}

export const PLAN_LOADING_MESSAGE = 'Still checking your plan. Try again in a moment.';
export const PLAN_ERROR_MESSAGE = "We couldn't check your plan. Try again.";

export function planNotReadyMessage(status: PlanStatus): string | null {
  if (status === 'ready') return null;
  return status === 'loading' ? PLAN_LOADING_MESSAGE : PLAN_ERROR_MESSAGE;
}
